import React from "react";
import UpdateCust from "../UpdateCust";

const CustomerMenu = ({
  // Current Property Check
  currentProp,

  // Customer Information
  customer, // { projectID, email }
  primaryContact,
  name,

  // Address Information
  phone,
  street,
  city,
  state,
  zip,

  // Callback Functions
  getCustomer,
  setUpdateCustomer,
  updateCustomer,

  // Responsive Design Props
  width,
  smallBreakPoint,
}) => {
  return (
    <>
      <div className="container">
        {currentProp ? (
          <div>
            <div>
              <UpdateCust
                primaryContact={primaryContact}
                name={name}
                projectID={customer.projectID}
                email={customer.email}
                phone={phone}
                street={street}
                city={city}
                state={state}
                zip={zip}
                getCustomer={getCustomer}
                setUpdateCustomer={setUpdateCustomer}
                updateCustomer={updateCustomer}
                width={width}
                smallBreakPoint={smallBreakPoint}
              />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default CustomerMenu;
